import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
// project imports
import Loadable from 'components/Loadable';
import MainLayout from 'layout/MainLayout';
import AuthGuard from 'routes/route-guard/AuthGuard';
import AuthRoleGuard from 'routes/route-guard/AuthRoleGuard';

const DashBoard = Loadable(lazy(() => import('views/dashboard')));
const Operations = Loadable(lazy(() => import('views/operations')));
const CertifiedCommunications = Loadable(lazy(() => import('views/certifiedCommunications')));
const ReportsGraphics = Loadable(lazy(() => import('views/reportsGraphics')));
const SendSign = Loadable(lazy(() => import('views/sendSign')));
const SignDocument = Loadable(lazy(() => import('views/signDocument')));
const SendOCR = Loadable(lazy(() => import('views/sendOCR')));
const VideoIdStart = Loadable(lazy(() => import('views/videoIdStart')));
const SendCertifiedCommunication = Loadable(lazy(() => import('views/sendCertifiedCommunication')));
const SendNormalCommunication = Loadable(lazy(() => import('views/sendNormalCommunication')));
const Profile = Loadable(lazy(() => import('views/profile')));
const Administration = Loadable(lazy(() => import('views/administration')));
const ConfigBrandView = Loadable(lazy(() => import('views/configBrand')));
const PreSignatureStampsView = Loadable(lazy(() => import('views/administration/preSignatureStamps')));
const PreSignatureStampsEditView = Loadable(
    lazy(() => import('views/administration/preSignatureStamps/PreSignatureStampsEditView'))
);
const ConfigTemplatesView = Loadable(lazy(() => import('views/configTemplates')));
const PdfTemplateCreateView = Loadable(lazy(() => import('views/configTemplates/pdfTemplates/PdfTemplateCreateView')));
const PdfTemplateEditView = Loadable(lazy(() => import('views/configTemplates/pdfTemplates/PdfTemplateEditView')));
const TemplateEditorView = Loadable(lazy(() => import('views/templateEditor')));
const Certificates = Loadable(lazy(() => import('views/certificates')));
const Devices = Loadable(lazy(() => import('views/devices')));
const CommunicationsConfig = Loadable(lazy(() => import('views/communicationsConfig')));
const Developers = Loadable(lazy(() => import('views/developers')));
const OcrView = Loadable(lazy(() => import('views/developers/OCR/ocrView')));
const OtpsView = Loadable(lazy(() => import('views/developers/Otps/otpsView')));
const VideoIdView = Loadable(lazy(() => import('views/developers/VideoId/videoIdView')));
const NotifierView = Loadable(lazy(() => import('views/developers/Notifier/notifierView')));
const CertifierView = Loadable(lazy(() => import('views/developers/Certifier/certifierView')));
const BiometricSignView = Loadable(lazy(() => import('views/developers/BiometricSign/BiometricSignView')));
const ElectronicSignView = Loadable(lazy(() => import('views/developers/ElectronicSign/ElectronicSignView')));
const AdministrationView = Loadable(lazy(() => import('views/developers/Administration/AdministrationView')));
const ApiOnboardingView = Loadable(lazy(() => import('views/developers/Api-Onboarding/ApiOnboradingView')));
const CallbacksView = Loadable(lazy(() => import('views/developers/Callbacks/CallbacksView')));
const TemplatesView = Loadable(lazy(() => import('views/developers/Templates/templatesView')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/',
            element: <DashBoard />,
            title: 'TITLE_HOME'
        },
        {
            path: '/dashboard',
            element: <DashBoard />,
            title: 'TITLE_HOME'
        },

        // Rutas para ver el historial de operaciones
        {
            path: '/history-operations',
            element: <Operations />,
            title: 'TITLE_HISTORY_OPERATIONS'
        },
        {
            path: '/history-communications',
            element: <CertifiedCommunications />,
            title: 'TITLE_HISTORY_COMMUNICATIONS'
        },
        {
            path: '/history-reports',
            element: <ReportsGraphics />,
            title: 'TITLE_HISTORY_REPORTS'
        },

        // Rutas para crear una nueva operación o comunicación
        {
            path: '/esign-sendsign',
            element: <AuthRoleGuard element={<SendSign />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_SEND_SIGN'
        },
        {
            path: '/esign-signdocument',
            element: <AuthRoleGuard element={<SignDocument />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_SIGN_DOCUMENT'
        },
        {
            path: '/ocr/send',
            element: <AuthRoleGuard element={<SendOCR />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_OCR'
        },
        {
            path: '/videoId/send',
            element: <AuthRoleGuard element={<VideoIdStart />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_VIDEO_ID'
        },
        // VoiceId is not implemented
        // {
        //     path: '/voiceId/operations',
        //     element: <VoiceIdOperations />
        // },
        // {
        //     path: '/voiceId/reports',
        //     element: <VoiceIdReports />
        // },

        {
            path: '/certified-communication/send',
            element: <AuthRoleGuard element={<SendCertifiedCommunication />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_SEND_CERTIFIED_COMMUNICATION'
        },
        {
            path: '/normal-communication/send',
            element: <AuthRoleGuard element={<SendNormalCommunication />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_SEND_NORMAL_COMMUNICATION'
        },

        // Rutas de configuración
        {
            path: '/profile',
            element: <AuthRoleGuard element={<Profile />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_PROFILE'
        },
        {
            path: '/admin',
            element: <AuthRoleGuard element={<Administration />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_ADMINISTRATION'
        },
        {
            path: '/config/brand-settings',
            element: <AuthRoleGuard element={<ConfigBrandView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_BRAND_SETTINGS'
        },
        {
            path: '/admin/pre-signature-stamps',
            element: <AuthRoleGuard element={<PreSignatureStampsView />} notAllowedRoles={['readonly']} />,
            title: 'SELLOS_PREFIRMA'
        },
        {
            path: '/config/templates',
            element: <AuthRoleGuard element={<ConfigTemplatesView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_CONFIG_TEMPLATES'
        },
        {
            path: '/config/pre-signature-stamps/edit',
            element: <AuthRoleGuard element={<PreSignatureStampsEditView />} notAllowedRoles={['readonly']} />,
            title: 'SELLOS_PREFIRMA'
        },
        {
            path: '/config/templates/pdf/new',
            element: <AuthRoleGuard element={<PdfTemplateCreateView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_CONFIG_TEMPLATES'
        },
        {
            path: '/config/templates/pdf/:id/edit',
            element: <AuthRoleGuard element={<PdfTemplateEditView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_CONFIG_TEMPLATES'
        },
        {
            path: '/template-editor/:id',
            element: <AuthRoleGuard element={<TemplateEditorView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_TEMPLATE_EDITOR'
        },
        {
            path: '/config/certificates',
            element: <AuthRoleGuard element={<Certificates />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_CERTIFICATES'
        },
        {
            path: '/config/devices',
            element: <AuthRoleGuard element={<Devices />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVICES'
        },
        {
            path: '/config/communications',
            element: <AuthRoleGuard element={<CommunicationsConfig isAdmin={false} />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_COMMUNICATIONS_SETTINGS'
        },

        // Rutas para desarrolladores
        {
            path: '/config/developers',
            element: <AuthRoleGuard element={<Developers />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS'
        },
        {
            path: '/config/developers/ocr',
            element: <AuthRoleGuard element={<OcrView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_OCR'
        },
        {
            path: '/config/developers/otps',
            element: <AuthRoleGuard element={<OtpsView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_OTPS'
        },
        {
            path: '/config/developers/videoId',
            element: <AuthRoleGuard element={<VideoIdView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_VIDEO_ID'
        },
        {
            path: '/config/developers/notifier',
            element: <AuthRoleGuard element={<NotifierView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_NOTIFIER'
        },
        {
            path: '/config/developers/certifier',
            element: <AuthRoleGuard element={<CertifierView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_CERTIFIER'
        },
        {
            path: '/config/developers/biometric-signature',
            element: <AuthRoleGuard element={<BiometricSignView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_BIOMETRIC_SIGNATURE'
        },
        {
            path: '/config/developers/electronic-signature',
            element: <AuthRoleGuard element={<ElectronicSignView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_ELECTRONIC_SIGNATURE'
        },
        {
            path: '/config/developers/administration',
            element: <AuthRoleGuard element={<AdministrationView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_ADMINISTRATION'
        },

        {
            path: '/api-onboarding',
            element: <AuthRoleGuard element={<ApiOnboardingView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_API_ONBOARDING'
        },
        {
            path: 'config/developers/callbacks',
            element: <AuthRoleGuard element={<CallbacksView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_CALLBACKS'
        },
        {
            path: '/config/developers/templates',
            element: <AuthRoleGuard element={<TemplatesView />} notAllowedRoles={['readonly']} />,
            title: 'TITLE_DEVELOPERS_TEMPLATES'
        },

        // Ruta por defecto
        {
            path: '*',
            element: <Navigate to="/" />
        }
    ]
};

export default MainRoutes;
